include ../../../../../common/primary/icon/icon.mixin.pug

.fp-alert.-info
  +fp-icon('info', {color: 'info', size: '18'})
  span.fp-text.-paragraph {{ t(alertText) }}
